

const inkProjectCard = {
  bindings: {
    card: '<',
    showFullDatetime: '<?',
    showEstimate: '<?',
    showArtist: '<?',
    showCollector: '<?',
    showDetails: '<?',
    showName: '<?',
    showStyle: '<?'
  },
  controller: function(Session, _) {
    this.showEstimate = _.isUndefined(this.showEstimate) ?
      true : this.showEstimate;
    if (_.isUndefined(this.showArtist) && Session.activeState &&
    Session.activeState.role === 'artist') {
      this.showArtist = false;
    } else if (_.isUndefined(this.showArtist) && Session.activeState &&
    Session.activeState.role !== 'artist') {
      this.showArtist = true;
    }
    this.showCollector = _.isUndefined(this.showCollector) ?
      true : this.showCollector;
    this.showDetails = _.isUndefined(this.showDetails) ?
      true : this.showDetails;
    this.showStyle = _.isUndefined(this.showStyle) ?
      true : this.showStyle;
    this.showEstimate = _.isUndefined(this.showEstimate) ?
      true : this.showEstimate;
    this.showName = _.isUndefined(this.showName) ?
        false : this.showName;
  },
  template: require('./project-cards.template.html')
};

angular
  .module('inkfinder')
  .component('inkProjectCard', inkProjectCard);



// WEBPACK FOOTER //
// ./components/projects/cards/project-cards.component.js